import _find from "lodash/find";
import jsCookie from 'js-cookie';
import * as React from 'react';
import useAsync from 'react-use/lib/useAsync';
import { campusApiClient } from '../api/campusApiClient';
export const useIsFreePreview = _ref => {
  let {
    chapterId,
    courseId,
    datacampDomain,
    environment,
    sentry
  } = _ref;
  const [result, setResult] = React.useState(undefined);
  const {
    error,
    value
  } = useAsync(async () => {
    var _currentChapter$free_;
    if (courseId === undefined || chapterId === undefined) {
      return undefined;
    }
    const {
      chapters,
      paid
    } = await campusApiClient(environment).getCourse(courseId);
    const currentChapter = _find(chapters, {
      id: chapterId
    });
    if (currentChapter === undefined) {
      return false;
    }
    const isFreeChapter = (_currentChapter$free_ = currentChapter.free_preview) !== null && _currentChapter$free_ !== void 0 ? _currentChapter$free_ : false;
    const isFreeCourse = !paid;
    return isFreeChapter || isFreeCourse;
  }, [courseId, chapterId, environment]);
  React.useEffect(() => {
    if (error !== undefined) {
      sentry.captureError(error, {
        chapterId,
        courseId
      });
    }
  }, [error, chapterId, courseId, sentry]);
  React.useEffect(() => {
    // If an error occurs when fetching the course detail
    // it's better to forbid free access
    const newResult = error === undefined ? value : false;
    jsCookie.set('rde-ifp', String(newResult), {
      domain: datacampDomain
    });
    setResult(newResult);
  }, [error, value, datacampDomain]);
  return result;
};